import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f40ba8f")

_pushScopeId("data-v-7f40ba8f")
const _hoisted_1 = { class: "dialog-auth-container-inner max-w-screen-3xl mx-auto bg-white md:w-screen" }
const _hoisted_2 = {
  class: "dialog-overlay-bg-img",
  style: {"width":"100%","max-width":"41.66666667"}
}
const _hoisted_3 = {
  key: 3,
  class: "hidden md:block w-full h-full",
  style: {"width":"41.66666667% height: calc(100vh - 120px)"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", {
  class: "inline-block h-screen align-middle",
  "aria-hidden": "true"
}, " ​ ", -1)
const _hoisted_5 = { class: "dialog-content-container max-w-screen-3xl mx-auto inline-block w-full h-full overflow-hidden overflow-y-auto transition-all transform bg-transparent bg-opacity-90 pt-0" }
const _hoisted_6 = { class: "h-full lg:h-auto md:flex px-4 md:px-0" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "modal-image hidden md:block w-5/12 max-w-740 h-full min-w-5/12 bg-transparent",
  style: {"min-width":"41.6666667%"}
}, null, -1)
const _hoisted_8 = { class: "modal-form h-full md:h-auto w-full md:w-7/12 relative mx-auto bg-white" }
const _hoisted_9 = { class: "absolute vh-center mx-auto w-full md:w-fixed-380" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")
  const _component_TransitionChild = _resolveComponent("TransitionChild")
  const _component_DialogTitle = _resolveComponent("DialogTitle")
  const _component_LoginForm = _resolveComponent("LoginForm")
  const _component_RegistrationForm = _resolveComponent("RegistrationForm")
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")
  const _component_DashBoardForm = _resolveComponent("DashBoardForm")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    appear: "",
    show: _ctx.modalOpened,
    as: "template"
  }, {
    default: _withId(() => [
      _createVNode(_component_Dialog, {
        as: "div",
        open: _ctx.modalOpened,
        onClose: _ctx.closeModal
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: ["dialog-auth-container bg-white fixed inset-0 z-50 overflow-y-auto", {'dialog-has-covid-track': (_ctx.hasCovidTrack === true || _ctx.hasCovidTrack === null)}]
          }, [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withId(() => [
                  _createVNode(_component_DialogOverlay, {
                    class: ["dialog-overlay fixed inset-0", {'dialog-has-covid-track': (_ctx.hasCovidTrack === true || _ctx.hasCovidTrack === null)}]
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_2, [
                        (_ctx.loginImages && (_ctx.showLogin || _ctx.showForgotPassword))
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: _ctx.loginImages[0]?.meta.MediaPath,
                              class: "hidden md:block w-full h-full object-cover"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (_ctx.dashboardImages && (_ctx.showDashBoardForm))
                          ? (_openBlock(), _createBlock("img", {
                              key: 1,
                              src: _ctx.dashboardImages[0]?.meta.MediaPath,
                              class: "hidden md:block w-full h-full object-cover"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (_ctx.registerImages && _ctx.showRegister)
                          ? (_openBlock(), _createBlock("img", {
                              key: 2,
                              src: _ctx.registerImages[0]?.meta.MediaPath,
                              class: "hidden md:block w-full h-full object-cover"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (!_ctx.loginImages && !_ctx.registerImages)
                          ? (_openBlock(), _createBlock("div", _hoisted_3))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }),
              _hoisted_4,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode("div", _hoisted_8, [
                        _createVNode("button", {
                          type: "button",
                          class: "close-auth-btn text-black absolute top-0 right-0 block text-60 z-10 transition-all duration-300 mr-2 -mt-2 cursor-pointer hover:text-htz-blue",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, " × "),
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_DialogTitle, {
                            as: "h3",
                            class: "modal-title text-htz-darkgrey text-32 font-livory text-center mb-12"
                          }, {
                            default: _withId(() => [
                              (_ctx.showLogin)
                                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('loc_login_title_login')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.showRegister)
                                ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('loc_login_title_registration')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.showForgotPassword)
                                ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('loc_login_send_email_forgot_password_title')), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (_ctx.showLogin)
                            ? (_openBlock(), _createBlock(_component_LoginForm, { key: 0 }))
                            : _createCommentVNode("", true),
                          (_ctx.showRegister)
                            ? (_openBlock(), _createBlock(_component_RegistrationForm, { key: 1 }))
                            : _createCommentVNode("", true),
                          (_ctx.showForgotPassword)
                            ? (_openBlock(), _createBlock(_component_ForgotPassword, { key: 2 }))
                            : _createCommentVNode("", true),
                          (_ctx.showDashBoardForm)
                            ? (_openBlock(), _createBlock(_component_DashBoardForm, { key: 3 }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["open", "onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
})